import React, { useContext, useEffect, useState } from 'react';
import { Button, Col, Form, InputGroup, Row, Spinner } from 'react-bootstrap';
import MaskedInput from 'react-text-mask';
import Select from 'react-select';

import { RedContext } from '../../../context/connection/ContextRed';
import { getEmiCl } from '../../../data/loopMap';
import { fetchConToken } from '../../../api/fetch';
import { useForm } from '../../../hooks/useForm';
import { useContextInfo } from '../../../context/ContextInfo';
import MapaRender from '../../map/MapaRender';
import { UserContext } from '../../../context/user/ContextUser';
import { AuthContext } from '../../../auth/AuthContext';
import { checkAccess } from '../../../helpers/details';

const EditWifi = ({ service, wifi, callBk, reload = false, red = false }) => {
    const { auth } = useContext(AuthContext);
    const { roll } = auth;
   

    const permisos = checkAccess('Servicios', auth.accesos);
    const {srv_editar, srv_editar_full } = permisos.functions
    const { setResp } = useContextInfo();
    const { redState } = useContext(RedContext);
    const { usersState } = useContext(UserContext);
    const [fire, setFire] = useState(service.firewall_state);
    const [validated, setValidated] = useState(false);
    const [load, setLoad] = useState(false);
    const [showMp, setshoMp] = useState(false);
    const [chE, setchE] = useState(false);
    const [mkRedes, setRedesMk] = useState([]);
    const [ipRed, setIpRed] = useState([]);
    const [coords, setCoord] = useState([]);
    const [loader, setLoader] = useState(true);

    const [emisorv, setEmi] = useState({ value: wifi?.id_emisor, label: wifi?.emisor });
    const emis = getEmiCl(redState.emisores, 'nombre');
    const [values, handleInputChange, setFormValue] = useForm({
        mknodo: service.mknodo,
        ser_tipo: 'INALAMBRICO',
        redIpv4: service.redIpv4,
        emisor: wifi?.id_emisor,
        antena: wifi?.id_antena,
        idperfil: wifi?.id_plan,
        ip: service.ip,
        mac: service.mac,
        id_tec: service.id_tec,
        coordenadas: service.coordenadas,
    });
    const { mknodo, redIpv4 } = values;
   
    const changeCoor = (coords) => {
        setFormValue({ ...values, coordenadas: coords });
    };
    useEffect(() => {
        passCoords();
    }, [values.coordenadas]);
    useEffect(() => {
        setLoader(true);
        setFormValue({
            mknodo: service.mknodo,
            ser_tipo: 'INALAMBRICO',
            redIpv4: service.redIpv4,
            emisor: wifi?.id_emisor,
            antena: wifi?.id_antena,
            idperfil: wifi?.id_plan,
            ip: service.ip,
            mac: service.mac,
            id_tec: service.id_tec,

            coordenadas: service.coordenadas,
        });
        setFire(service.firewall_state);
        setTimeout(() => {
            setLoader(false);
        }, 2000);
    }, [reload, service, wifi]);

    useEffect(() => {
        getIpv4();
    }, [mknodo]);
    useEffect(() => {
        !emisorv.value ? setchE(true) : setchE(false);
    }, [emisorv, reload]);

    useEffect(() => {
        getIp();
    }, [redIpv4]);
    useEffect(() => {
        setEmi({ value: wifi.id_emisor, label: wifi?.emisor });
    }, [wifi]);
    useEffect(() => {
        setFire(service.firewall_state);
    }, [service]);
    //!obtine los ipv4 redes qu epertenecen al mktik
    const getIpv4 = async () => {
        if (mknodo) {
            const re = await fetchConToken(`networks/ipv4bymkt/${mknodo}`);
            if (re.ok) setRedesMk(re.data);
        } else {
            setIpRed([]);
            setRedesMk([]);
            setFormValue({ ...values, ip: '' });
        }
    };
    // !obtiene las ips del ipv4 red
    const getIp = async () => {
        if (redIpv4.length) {
            const res = await fetchConToken(`servis/ip/${values.redIpv4}/${service.ip}`);

            if (res.ok) {
                setIpRed(res.data);
                if (values.redIpv4 === service.redIpv4) {
                    setFormValue({ ...values, ip: service.ip });
                } else {
                    setFormValue({ ...values, ip: res.data[0] });
                }
            }
        } else {
            setIpRed([]);
            setFormValue({ ...values, ip: '' });
        }
    };

    const passCoords = () => {
        if (values.coordenadas?.length > 0) {
            const arr = values?.coordenadas.split(',');
            if (arr.length > 1) {
                setCoord([{ lat: parseFloat(arr[0]), lng: parseFloat(arr[1]) }]);
            }
        }
    };
    const changeEmI = (pay) => {
        setEmi(pay);
        if (pay.value === '') {
            setchE(true);
        }
    };
    const onSubmit = async (e) => {
        const form = e.currentTarget;
        e.preventDefault();
        if (load || chE) return;
        setLoad(true);
        if (form.checkValidity() === false) {
            setValidated(true);
        } else {
            const result = mkRedes.find((red) => red.subred === redIpv4);

            const data = {
                mknodo: values.mknodo,
                firewall_state: fire,
                ser_tipo: values.ser_tipo,
                redIpv4: values.redIpv4,
                idIpv4: result.id,
                ip: values.ip,
                mac: values.mac,
                id_tec: values.id_tec,
                coordenadas: values.coordenadas,
                instalado: values.instalado,
            };
            const wifi = {
                id_plan: values.idperfil,
                id_emisor: emisorv.value,
                id_antena: values.antena,
            };
            const res = await fetchConToken(
                `user/service/${service.id}`,
                {
                    service: data,
                    type: wifi,
                },
                'PUT'
            );
            setResp(res);
            setLoad(false);

            callBk();
        }
        setLoad(false);
    };
    return (
        <div>
            {' '}
            <>
                <Row>
                    <Col>
                        <Form noValidate validated={validated} onSubmit={onSubmit}>
                            <Row>
                                <Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                            <Form.Label>Router</Form.Label>
                                            <Form.Select
                                                value={values.mknodo}
                                                name="mknodo"
                                                required
                                                disabled={!srv_editar_full}
                                                onChange={handleInputChange}>
                                                <option value="">Selecciona un Router </option>

                                                {redState.mktiks.map((mk, i) => (
                                                    <option value={mk.id} key={i}>
                                                        {mk.nodo}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                            <Form.Label> Plan de internet</Form.Label>
                                            <Form.Select
                                                value={values.idperfil}
                                                name="idperfil"
                                                required
                                                disabled={!srv_editar_full}
                                                onChange={handleInputChange}>
                                                <option value="">Selecciona un plan </option>
                                                {redState.internet.map((int, i) => {
                                                    if (!int.disabled) {
                                                        return (
                                                            <option value={int.id} key={i}>
                                                                {int.plan}
                                                            </option>
                                                        );
                                                    }
                                                    if (int.id === values.idperfil) {
                                                        return (
                                                            <option value={int.id} key={i}>
                                                                {int.plan}
                                                            </option>
                                                        );
                                                    }
                                                    return null;
                                                })}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                            <Form.Label> Redes IPv4</Form.Label>
                                            <Form.Select
                                                value={values.redIpv4}
                                                name="redIpv4"
                                                required
                                                disabled={!srv_editar_full}
                                                onChange={handleInputChange}>
                                                <option value="">Seleccionar... </option>

                                                {mkRedes.map((iv) => (
                                                    <option value={iv.subred} key={iv.subred}>
                                                        {iv.subred} ( {iv.host - iv.us} Ips disponibles) {iv.nombre}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                            <Form.Label> IPv4</Form.Label>
                                            <Form.Select
                                                value={values.ip}
                                                name="ip"
                                                disabled={!srv_editar_full}
                                                onChange={handleInputChange}>
                                                <option value="">Selecciona una red </option>
                                                {ipRed.map((ip, i) => (
                                                    <option value={ip} key={i}>
                                                        {ip}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3" controlId="validationCustom1">
                                            <Form.Label>Mac</Form.Label>
                                            <MaskedInput
                                                mask={[
                                                    /[A-Fa-f0-9]/,
                                                    /[A-Fa-f0-9]/,
                                                    ':',
                                                    /[A-Fa-f0-9]/,
                                                    /[A-Fa-f0-9]/,
                                                    ':',
                                                    /[A-Fa-f0-9]/,
                                                    /[A-Fa-f0-9]/,
                                                    ':',
                                                    /[A-Fa-f0-9]/,
                                                    /[A-Fa-f0-9]/,
                                                    ':',
                                                    /[A-Fa-f0-9]/,
                                                    /[A-Fa-f0-9]/,
                                                    ':',
                                                    /[A-Fa-f0-9]/,
                                                    /[A-Fa-f0-9]/,
                                                ]}
                                                required
                                                type="text"
                                                className="form-control text-uppercase"
                                                name="mac"
                                                disabled={!srv_editar_full}
                                                onChange={handleInputChange}
                                                value={values.mac}
                                            />
                                            <Form.Control.Feedback>Válido</Form.Control.Feedback>
                                        </Form.Group>{' '}
                                    </Col>
                                </Col>
                                <Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                            <Form.Label> Técnico</Form.Label>
                                            <Form.Select
                                                value={values.id_tec}
                                                name="id_tec"
                                                required
                                                disabled={!srv_editar_full}
                                                onChange={handleInputChange}>
                                                <option value="0">Sin asignar </option>

                                                {usersState?.agentes
                                                    .filter(({ campo }) => campo === true)
                                                    .map(({ id_agent, name }) => (
                                                        <option value={id_agent} key={id_agent}>
                                                            {name}
                                                        </option>
                                                    ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom19">
                                            <Form.Label>Emisor</Form.Label>
                                            <Select
                                                required
                                                className="react-select"
                                                maxMenuHeight="550px"
                                                value={emisorv}
                                                onChange={changeEmI}
                                                options={emis}
                                                disabled={!srv_editar}

                                                classNamePrefix="react-select"
                                            />
                                            {chE && (
                                                <strong>
                                                    {' '}
                                                    <label className="text-danger">*EL emisor es obligatorio</label>
                                                </strong>
                                            )}{' '}
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom0">
                                            <Form.Label> Tipo de antena</Form.Label>
                                            <Form.Select
                                                value={values.antena}
                                                name="antena"
                                                required
                                                disabled={!srv_editar}

                                                onChange={handleInputChange}>
                                                <option value="">Ninguno </option>

                                                {redState.fabricantes.map((z) => (
                                                    <option value={z.id} key={z.id}>
                                                        {z.nombre}
                                                    </option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>{' '}
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom08">
                                            <Form.Label>Coordenadas</Form.Label>
                                            <InputGroup>
                                                <InputGroup.Text
                                                    id="inputGroupPrepend"
                                                    onClick={() => setshoMp(!showMp)}>
                                                    <i className="mdi mdi-map-marker-radius" />
                                                </InputGroup.Text>
                                                <Form.Control
                                                    type="text"
                                                    value={values.coordenadas}
                                                    name="coordenadas"
                                                disabled={!srv_editar}

                                                    onChange={handleInputChange}
                                                />
                                            </InputGroup>
                                        </Form.Group>{' '}
                                    </Col>{' '}
                                    <Col>
                                        {' '}
                                        <Form.Group className="mb-3" controlId="validationCustom0999">
                                            <Form.Check
                                                checked={fire}
                                                disabled={!srv_editar_full}
                                                onChange={() => setFire(!fire)}
                                                type="switch"
                                                label="Excluir firewall"
                                                className="mt-1"
                                            />{' '}
                                        </Form.Group>
                                    </Col>
                                </Col>
                            </Row>{' '}
                            {load ? (
                                <Button color="primary" disabled>
                                    <Spinner className="spinner-border-sm me-1" tag="span" color="white" />
                                    Guardando...
                                </Button>
                            ) : (
                                <Button type="submit">Guardar</Button>
                            )}
                        </Form>
                    </Col>
                </Row>
            </>
            <MapaRender
                show={showMp}
                onClose={() => setshoMp(false)}
                legend="Emisor"
                marks={coords}
                setCoor={changeCoor}
            />
        </div>
    );
};

export default EditWifi;
